var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.909 46.592l-7.094 11.312L4.643 51.96c-1.534-.383-3.068.384-3.451 1.918C1 54.26 1 54.453 1 54.836v12.462c0 1.534.959 3.068 2.684 3.451 1.917.575 3.835-.575 4.41-2.492 0-.384.191-.576.191-.959v-4.985l16.872 6.135c1.725.576 3.643 0 4.793-1.533l2.3-3.26",
    stroke: "#474747",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.22 49.468l11.695 14.187c.767.959 1.342 2.11 1.533 3.26l2.684 15.146h4.794a3.437 3.437 0 013.45 3.45c0 1.918-1.533 3.643-3.45 3.643h-11.12c-1.342 0-2.493-.958-2.684-2.3l-3.835-18.98-12.845-11.312c-5.752-4.218-1.342-9.97-1.342-9.97l11.311-21.28c2.11-3.068 6.327-4.027 9.586-2.302 2.876 1.343 10.353 8.053 10.353 8.053h12.846c2.3 0 4.218 1.917 4.218 4.218 0 2.3-1.918 4.218-4.41 4.218H59.283L53.53 35.28l-8.436 17.063",
    stroke: "#474747",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.691 46.592v2.876h25.5V21.093h-25.5v2.876M70.784 8.248H52.187M55.067 18.026a8.436 8.436 0 100-16.872 8.436 8.436 0 000 16.872zM35.125 21.093h-15.53M10.968 21.093H8.092M18.063 35.28H1M23.814 8.248H5.217",
    stroke: "#474747",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.c1eb7148.svg";
export { ForwardRef as ReactComponent };